



































































































































































































































import Vue from 'vue';
import axios from 'axios';
import InputNumerc from '@/components/InputNumerc.vue';
import { defineComponent } from '@vue/composition-api';
import { accessor } from '../store';

export default defineComponent({
  components: {
    InputNumerc
  },
  data() {
    return {
      message: '',
      url: '',
      isLoading: false,
      messageSinseisyaName: '',
      messageTantoName: '',
      messageTanto: '',
      messageTantoTel: '',
      messageRiyou: '',
      messageSinseiName: '',
      messageWasteHandle: '',
      messageSector: '',
      messagePermissionLimit: '',
      messageTel: '',
      messageTantoNameU: '',
      messageTantoU: '',
      messageTantoTelU: '',
      messageRiyouU: '',
      openDialog: false,
      cardFlag: '',
      dialogItems: {
        title: '',
        text: '',
        textCss: '',
        cancelCss: '',
        okCss: '',
        cancelBtnText: '',
        sizeCss: ''
      },
      errorMessageCode: 0,
      cancelCall: function() {
        this.openDialog = false;
      }
    };
  },
  computed: {
    flag: {
      get() {
        return accessor.newFlag;
      },
      set(value) {
        accessor.setNewFlag(value);
      }
    },
    kyokaNo1: {
      get() {
        return accessor.newKyokaNo1;
      },
      set(value) {
        accessor.setNewKyokaNo1(value);
      }
    },
    kyokaNo2: {
      get() {
        return accessor.newKyokaNo2;
      },
      set(value) {
        accessor.setNewKyokaNo2(value);
      }
    },
    sinseiName: {
      get() {
        return accessor.newSinseiName;
      },
      set(value) {
        accessor.setNewSinseiName(value);
      }
    },
    wasteHandle: {
      get() {
        return accessor.newWasteHandle;
      },
      set(value) {
        accessor.setNewWasteHandle(value);
      }
    },
    wasteHandleDisp: {
      get() {
        return accessor.newWasteHandleDisp;
      },
      set(value) {
        accessor.setNewWasteHandleDisp(value);
      }
    },
    sector: {
      get() {
        return accessor.newSector;
      },
      set(value) {
        accessor.setNewSector(value);
      }
    },
    sectorDisp: {
      get() {
        return accessor.newSectorDisp;
      },
      set(value) {
        accessor.setNewSectorDisp(value);
      }
    },
    permissionLimit: {
      get() {
        return accessor.newPermissionLimit;
      },
      set(value) {
        accessor.setNewPermissionLimit(value);
      }
    },
    permissionLimitDisp: {
      get() {
        return accessor.newPermissionLimitDisp;
      },
      set(value) {
        accessor.setNewPermissionLimitDisp(value);
      }
    },
    tel: {
      get() {
        return accessor.newTel;
      },
      set(value) {
        accessor.setNewTel(value);
      }
    },
    kindValue: {
      get() {
        return accessor.newKindValue;
      },
      set(value) {
        accessor.setNewKindValue(value);
      }
    },
    torikindValue: {
      get() {
        return accessor.newTorikindValue;
      },
      set(value) {
        accessor.setNewTorikindValue(value);
      }
    },
    gyokindValue: {
      get() {
        return accessor.newGyokindValue;
      },
      set(value) {
        accessor.setNewGyokindValue(value);
      }
    },
    sinseisyaName: {
      get() {
        return accessor.newSinseisyaName;
      },
      set(value) {
        if (value !== '') {
          this.messageSinseisyaName = '';
        }
        accessor.setNewSinseisyaName(value);
      }
    },
    checkedTanto: {
      get() {
        return accessor.newCheckedTanto;
      },
      set(value) {
        accessor.setNewCheckedTanto(value);
      }
    },
    checkedRiyou: {
      get() {
        return accessor.newCheckedRiyou;
      },
      set(value) {
        accessor.setNewCheckedRiyou(value);
      }
    },
    tantoName: {
      get() {
        return accessor.newTantoName;
      },
      set(value) {
        if (value !== '') {
          this.messageTantoName = '';
        }
        accessor.setNewTantoName(value);
      }
    },
    tantoNameU: {
      get() {
        return accessor.newTantoNameU;
      },
      set(value) {
        if (value !== '') {
          this.messageTantoNameU = '';
        }
        accessor.setNewTantoNameU(value);
      }
    },
    checkedTantoU: {
      get() {
        return accessor.newCheckedTantoU;
      },
      set(value) {
        accessor.setNewCheckedTantoU(value);
      }
    },
    checkedRiyouU: {
      get() {
        return accessor.newCheckedRiyouU;
      },
      set(value) {
        accessor.setNewCheckedRiyouU(value);
      }
    },
    tantoTel: {
      get() {
        return accessor.newTantoTel;
      },
      set(value) {
        accessor.setNewTantoTel(value);
        if (!value || value.match(/^[0-9-]+$/)) {
          this.messageTantoTel = '';
        } else {
          this.messageTantoTel = '連絡先電話番号は半角数字、またはハイフンで入力してください。';
        }
      }
    },
    tantoTelU: {
      get() {
        return accessor.newTantoTelU;
      },
      set(value) {
        accessor.setNewTantoTelU(value);
        if (!value || value.match(/^[0-9-]+$/)) {
          this.messageTantoTelU = '';
        } else {
          this.messageTantoTelU = '連絡先電話番号は半角数字、またはハイフンで入力してください。';
        }
      }
    }
  },
  methods: {
    // 申請種類選択の変更イベント
    onKindChange() {
      if (this.kindValue === '0') {
        this.flag = '0';
        // 新規の場合、許可情報をクリア
        this.sinseiName = '';
        this.wasteHandleDisp = '';
        this.sectorDisp = '';
        this.permissionLimitDisp = '';
        this.tel = '';
        this.kyokaNo1 = '';
        this.kyokaNo2 = '';
        this.permissionLimit = '';
      } else {
        this.flag = '1';
      }
    },
    // 許可番号1から申請情報を取得する
    kyokaNoBlur1() {
      if (this.kyokaNo1 === '') {
        this.message = '許可番号を入力してください。';
        accessor.setNewSinseiName('');
        accessor.setNewWasteHandle('');
        accessor.setNewWasteHandleDisp('');
        accessor.setNewSector('');
        accessor.setNewPermissionLimit('');
        accessor.setNewTel('');
        accessor.setNewSectorDisp('');
        accessor.setNewPermissionLimitDisp('');
      } else {
        if (this.kyokaNo1.length !== 2) {
          this.message = '許可番号は2桁で入力してください。';
          accessor.setNewSinseiName('');
          accessor.setNewWasteHandle('');
          accessor.setNewWasteHandleDisp('');
          accessor.setNewSector('');
          accessor.setNewPermissionLimit('');
          accessor.setNewTel('');
          accessor.setNewSectorDisp('');
          accessor.setNewPermissionLimitDisp('');
        } else {
          if (this.kyokaNo1 !== '' && this.kyokaNo2 !== '') {
            this.getShinseiByKyokaNo();
          }
        }
      }
    },
    // 許可番号2から申請情報を取得する
    kyokaNoBlur2() {
      if (this.kyokaNo2 === '') {
        this.message = '許可番号を入力してください。';
        accessor.setNewSinseiName('');
        accessor.setNewWasteHandle('');
        accessor.setNewWasteHandleDisp('');
        accessor.setNewSector('');
        accessor.setNewPermissionLimit('');
        accessor.setNewTel('');
        accessor.setNewSectorDisp('');
        accessor.setNewPermissionLimitDisp('');
      } else {
        if (this.kyokaNo2.length !== 6) {
          this.message = '許可番号は6桁で入力してください。';
          accessor.setNewSinseiName('');
          accessor.setNewWasteHandle('');
          accessor.setNewWasteHandleDisp('');
          accessor.setNewSector('');
          accessor.setNewPermissionLimit('');
          accessor.setNewTel('');
          accessor.setNewSectorDisp('');
          accessor.setNewPermissionLimitDisp('');
        } else {
          if (this.kyokaNo1 !== '' && this.kyokaNo2 !== '') {
            this.getShinseiByKyokaNo();
          }
        }
      }
    },
    getShinseiByKyokaNo() {
      const data = JSON.stringify({
        kyokaNo1: this.kyokaNo1,
        kyokaNo2: this.kyokaNo2,
        kindValue: this.kindValue
      });
      const url = Vue.prototype.$API_URL + 'common';
      axios.post(url, data, Vue.prototype.$AXIOS_REQ_HEADER)
        .then(response => {
          // 表示されているメッセージをクリア
          this.messageWasteHandle = '';
          this.messageSector = '';
          this.messagePermissionLimit = '';
          this.messageTel = '';

          accessor.setNewSinseiName(response.data.sinseiName);
          accessor.setNewWasteHandle(response.data.wasteHandle);
          accessor.setNewWasteHandleDisp(response.data.wasteHandleDisp);
          accessor.setNewSector(response.data.sector);
          accessor.setNewPermissionLimit(String(response.data.permissionLimit));
          accessor.setNewTel(response.data.tel);
          accessor.setNewSectorDisp(response.data.sectorDisp);
          accessor.setNewPermissionLimitDisp(response.data.permissionLimitDisp);
          this.message = '';
          //許可期限に問題がある場合
          this.dialogItems.title = response.data.errorMessageTitle;
          this.dialogItems.text = response.data.errorMessageText;
          this.dialogItems.cancelCss = 'blue';
          this.dialogItems.cancelBtnText = '戻る';
          this.errorMessageCode = response.data.errorMessageCode;
          this.cancelCall = this.cancelBtn;
          if ((this.errorMessageCode === 3) || (this.errorMessageCode === 4)) {
            this.dialogItems.textCss = 'redtext';
            this.dialogItems.sizeCss = 'big';
          } else {
            this.dialogItems.textCss = 'blacktext';
            this.dialogItems.sizeCss = 'nomal';
          }
          if ((this.errorMessageCode === 1) || (this.errorMessageCode === 6)) {
            this.openDialog = true;
          }
          if ((this.errorMessageCode === 2) || (this.errorMessageCode === 3)) {
              this.openDialog = true;
              this.flag = '2';
          }
        }).catch((ex) => {
          if (ex.response) {
            console.error(ex.response.data.error);
          }
          this.message = '入力した許可番号に誤りがあります。';
      });
    },
    toPrev() {
        this.$router.push('/advice');
    },
    validate() {
      var result = true;
      this.messageSinseisyaName = '';
      this.messageTantoName = '';
      this.messageTanto = '';
      this.messageTantoTel = '';
      this.messageRiyou = '';
      this.messageSinseiName = '';
      this.messageWasteHandle = '';
      this.messageSector = '';
      this.messagePermissionLimit = '';
      this.messageTel = '';
      this.messageTantoNameU = '';
      this.messageTantoU = '';
      this.messageTantoTelU = '';
      this.messageRiyouU = '';
      if (this.kindValue === '0') {
        // (新規)申請者名
        if (this.sinseisyaName === '') {
          this.messageSinseisyaName = '申請者名を入力してください。';
          result = false;
        } else {
          this.messageSinseisyaName = '';
        }
        // (新規)担当者名
        if (this.tantoName === '') {
          this.messageTantoName = '担当者名を入力してください。';
          result = false;
        } else {
          this.messageTantoName = '';
        }
        // (新規)担当者種別
        if (this.checkedTanto.length === 0) {
          this.messageTanto = '担当者種別を入力してください。';
          result = false;
        } else {
          this.messageTanto = '';
        }
        // (新規)連絡先電話番号
        if (this.tantoTel === '') {
          this.messageTantoTel = '連絡先電話番号を入力してください。';
          result = false;
        } else if (!this.tantoTel.match(/^[0-9-]+$/)) {
          this.messageTantoTel = '連絡先電話番号は半角数字、またはハイフンで入力してください。';
          result = false;
        } else {
          this.messageTantoTel = '';
        }
        // (新規)先行許可制度
        if (this.checkedRiyou.length === 0) {
          this.messageRiyou = '先行許可制度を入力してください。';
          result = false;
        } else {
          this.messageRiyou = '';
        }
      } else {
        // (新規以外)申請者名
        if (this.sinseiName === '' || this.sinseiName === null) {
          this.message = '許可番号を入力してください。';
          //this.messageSinseiName = '申請者名を入力してください。';
          result = false;
        } else {
          this.message = '';
        }
        // 取扱う産業廃棄物
        if (this.wasteHandle === '') {
          this.messageWasteHandle = '取扱う産業廃棄物を入力してください。';
          result = false;
        }
        // 業の区分
        if (this.sector === '') {
          this.messageSector = '業の区分を入力してください。';
          result = false;
        }
        // 許可の有効期限
        if (this.permissionLimit === '') {
          this.messagePermissionLimit = '許可の有効期限を入力してください。';
          result = false;
        }
        // 連絡先
        /* 連絡先が未登録のデータもあるため、必須チェックとしない
        if (this.tel === '') {
          this.messageTel = '連絡先を入力してください。';
          result = false;
        }
        */
        // (新規以外)担当者名
        if (this.tantoNameU === '') {
          this.messageTantoNameU = '担当者名を入力してください。';
          result = false;
        }
        // (新規以外)担当者種別
        if (this.checkedTantoU.length === 0) {
          this.messageTantoU = '担当者種別を入力してください。';
          result = false;
        }
        // (新規以外)連絡先電話番号
        if (this.tantoTelU === '') {
          this.messageTantoTelU = '連絡先電話番号を入力してください。';
          result = false;
        } else if (!this.tantoTelU.match(/^[0-9-]+$/)) {
          this.messageTantoTelU = '連絡先電話番号は半角数字、またはハイフンで入力してください。';
          result = false;
        }
        // (新規以外)先行許可制度
        if (this.checkedRiyouU.length === 0) {
          this.messageRiyouU = '先行許可制度を入力してください。';
          result = false;
        }
      }
      return result;
    },
    toNext() {
      //許可番号チェック
      const data = JSON.stringify({
        kyokaNo1: this.kyokaNo1,
        kyokaNo2: this.kyokaNo2,
        kindValue: this.kindValue
      });
      const url = Vue.prototype.$API_URL + 'common';
      axios.post(url, data, Vue.prototype.$AXIOS_REQ_HEADER)
        .then(response => {
          //許可期限に問題がある場合
          this.dialogItems.title = response.data.errorMessageTitle;
          this.dialogItems.text = response.data.errorMessageText;
          this.dialogItems.cancelCss = 'blue';
          this.dialogItems.cancelBtnText = '戻る';
          this.errorMessageCode = response.data.errorMessageCode;
          this.cancelCall = this.cancelBtn;
          if ((this.errorMessageCode === 3) || (this.errorMessageCode === 4)) {
            this.dialogItems.textCss = 'redtext';
            this.dialogItems.sizeCss = 'big';
          } else {
            this.dialogItems.textCss = 'blacktext';
            this.dialogItems.sizeCss = 'nomal';
          }
          if ((this.errorMessageCode === 1) || (this.errorMessageCode === 6)) {
            this.openDialog = true;
            return false;
          }
          //画面遷移
          if ((this.kindValue === '0' && (this.torikindValue === '1' || this.gyokindValue === '1' || this.gyokindValue === '2')) ||
            (this.kindValue !== '0' && (this.kyokaNo1 === '10' || this.kyokaNo1 === '20' || this.kyokaNo1 === '60' || this.kyokaNo1 === '70'))) {
            this.flag = '2';
          } else {
            if (this.validate()) {
              this.$router.push('/place');
            }
          }
        }).catch((ex) => {
          if (ex.response) {
            console.error(ex.response.data.error);
          }
          this.message = '入力した許可番号に誤りがあります。';
        });
    },
    cancelBtn() {
      this.openDialog = false;
    },
    okBtn() {
      this.openDialog = false;
    }
  }
});
